const initState=[];
const CaregiverRecordReducer = (state = initState, action) => {
    switch(action.type) {
        case  'CaregiverRecordAction' : return  action.payload ;
        default: return state;
    }
}
export default CaregiverRecordReducer;